import { readonly, ref, shallowRef, computed } from "vue";
import { getDealersForLocator } from "@/core/api/graphql/organization";
import { Logger } from "@/core/utilities";
import type { ContactTypeOrganizationsArgs, Organization } from "@/core/api/graphql/types";

export function useDealersForLocator() {
  const loading = ref(false);
  const dealersForLocator = shallowRef<Organization[]>([]);

  async function fetchDealersForLocator(payload?: ContactTypeOrganizationsArgs) {
    try {
      loading.value = true;
      const { items = [] } = await getDealersForLocator(payload);

      dealersForLocator.value = items;
    } catch (e) {
      Logger.error(`${useDealersForLocator.name}.${fetchDealersForLocator.name}`, e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return {
    fetchDealersForLocator,
    loading: readonly(loading),
    dealersForLocator: computed(() => dealersForLocator.value),
  };
}
